ch-tree-view {
  display: flex;
  position: relative;
  block-size: 100%;
  inline-size: 100%;
  overflow: auto;
}
ch-tree-view > .ch-tree-view-container {
  position: absolute;
  inset: 0;
}
ch-tree-view.ch-tree-view-dragging-item ch-tree-view-item {
  pointer-events: var(--ch-tree-view-pointer-events, all);
}
ch-tree-view.ch-tree-view-dragging-item .ch-tree-view-list-item--deny-drop {
  pointer-events: none;
}
ch-tree-view.ch-tree-view--dragging-selected-items ch-tree-view-item[selected] {
  --ch-tree-view-pointer-events: none;
}
ch-tree-view.ch-tree-view-waiting-drop-processing {
  cursor: wait;
}
ch-tree-view.ch-tree-view-waiting-drop-processing > .ch-tree-view-container {
  pointer-events: none;
}

.ch-tree-view-drag-info {
  --rtl-offset: 16px;
  position: fixed;
  left: 0;
  top: 0;
  transform: translate(calc(var(--ch-tree-view-dragging-item-x) + var(--rtl-offset)), calc(var(--ch-tree-view-dragging-item-y) + 8px));
  pointer-events: none;
  z-index: 1;
  animation: ch-tree-view-drag-info-fade-in 10ms;
}

@keyframes ch-tree-view-drag-info-fade-in {
  0%, 100% {
    opacity: 0;
  }
}
html[dir=rtl] .ch-tree-view-drag-info {
  --rtl-offset: -100%;
}